export default __webpack_public_path__ + "static/media/1_2.7bb4dcd1.png";